import PropTypes from "prop-types";

import { TableItemsCounterWrapper } from "./styled";

const TableItemsCounter = ({ appsCount }) => {
  return (
    <TableItemsCounterWrapper>
      <span>{appsCount}</span>
    </TableItemsCounterWrapper>
  );
};

TableItemsCounter.propTypes = {
  appsCount: PropTypes.number.isRequired
};

export default TableItemsCounter;
